var angularModule = angular.module('t2g.common.services.3rdParty', []);

module.exports = angularModule;

angularModule.factory('moment', function() {
    return window.moment;
});
